<template>
    <el-container class="main-container">
        <el-header class="service-header">
            <img class="auth-logo" src="/images/logo.webp" alt="BonTravelIndia" style="height: 42px; width: auto; max-width: 160px; object-fit: contain;">
        </el-header>
        <el-main class="el-mainn">
            <div class="custom-container">
                <el-card class="box-card" width="500">
                    <template #header>
                        <div class="card-header">
                            <el-text class="htext" tag="p">Bon Travel CRM</el-text>
                        </div>
                    </template>

                    <el-text class="text" tag="p">Enter Security Code to continue</el-text>

                    <div style="display: flex; flex-direction: row">
                        <v-otp-input
                            ref="otpInput"
                            v-model:value="otp"
                            input-classes="otp-input"
                            separator="-"
                            :num-inputs="6"
                            :should-auto-focus="true"
                            input-type="letter-numeric"
                            :conditionalClass="['one', 'two', 'three', 'four', 'five', 'six']"
                            :placeholder="['*', '*', '*', '*', '*', '*']"
                            @on-complete="submit"
                            :is-disabled="loading"
                        />
                    </div>

                    <el-text v-if="result && result.success == false" class="mx-6" type="danger">
                        {{ result.message }}
                    </el-text>

                    <el-button
                        class="cbtn"
                        type="primary"
                        :disabled="loading || otp.length !== 6"
                        :loading="loading"
                        round
                    >Continue</el-button>

                </el-card>
            </div>
        </el-main>
    </el-container>
</template>

<script>
import VOtpInput from "vue3-otp-input";
import {
    ElContainer, ElHeader, ElMain, ElAside, ElCard, ElButton, ElText, ElSpace
} from 'element-plus';
import 'element-plus/dist/index.css';

export default {
    name: "OtpVerify",
    components: {
        ElContainer, ElHeader, ElMain, ElAside, ElCard, ElButton, VOtpInput, ElText, ElSpace
    },
    data() {
        return {
            otp: '',
            loading: false,
            result: null
        };
    },
    methods: {
        submit() {
            this.loading = true;
            let currentObj = this;
            axios.post('/verifyotp', { otp: this.otp }).then(function (response) {
                currentObj.result = response.data;
                currentObj.loading = false;
                currentObj.otp = "";
                if (currentObj.result.success) {
                    window.location.href = "/login";
                }
            }).catch(function (error) {
                currentObj.loading = false;
                currentObj.otp = "";
            });
        }
    }
};
</script>

<style scoped>
.custom-container {
}

.main-container {
    background-image: url('/images/otpback1.jpg');
    background-size: cover;
    height: 100vh;
}

.service-header {
    display: flex;
    align-items: center;
    height: 60px;
    padding: 0 20px;
    background: #fff;
}

.auth-logo {
    height: 42px;
    width: auto;
    max-width: 160px;
    object-fit: contain;
}

.el-mainn {
    background-color: #b9b9b93b;
}

.box-card {
    margin: 100px auto;
    width: fit-content;
}

.side {
    --el-aside-width: 400px;
    align-items: center;
    display: flex;
}

.card-header {
    text-align: center;
}

.text {
    text-align: center;
    font-weight: 700;
    margin-bottom: 19px;
    font-size: 17px;
}

.htext {
    text-align: center;
    font-weight: 700;
    font-size: 25px;
    color: white;
}

.el-card__header_1 {
    background-color: #e6e6e6;
}

.cbtn {
    margin-top: 20px;
    width: 100%;
}
</style>